import moment from 'moment-timezone';

const getTimeSinceLastPickup = (pickup) => {
    const now = moment();
    const lastPickupTime = pickup.created_at;
    return now.diff(lastPickupTime);
};

export default getTimeSinceLastPickup;
